import React, { useEffect, useState } from 'react';
import { RichTextEditorComponent, Toolbar, Inject, Image, Link, HtmlEditor, Count, QuickToolbar, Table } from '@syncfusion/ej2-react-richtexteditor';
import { storePurpose } from "../../utils/Purpose";
import { env } from '../../env'
export default function RichTextEditorControl(props) {
    let editor;
    const { id, purposeId, name, label, setValue, defaultValue, height, refresh, allowEditing } = props;
  
    const insertImageSettings = {
        saveFormat: 'base64',
    };

    const quickToolbarSettings = {
        table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles'],
        enable: allowEditing
    };
    //Rich Text Editor ToolbarSettings
    const toolbarSettings = {
        items: allowEditing ? ['FullScreen', '|', 'Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|', 'Undo', 'Redo', '|',
            'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
            'Outdent', 'Indent', 'SuperScript', 'SubScript', '|',
            'CreateTable', 'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
            'SourceCode'
        ] : [],
    };

    // UseEffects 
    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`RichTextEditorControl.useEffect :: refresh: ${refresh}`);
        }

        if (refresh === true && defaultValue !== '') {
            setValue(name, defaultValue)
            editor.value = defaultValue;
            editor.refreshUI();
        }

    }, [defaultValue, refresh, label]);

    const handleOnChange = (args) => {
        if (args !== undefined) {
            setValue(name, args)
            storePurpose(`df.${id}.let`, args, purposeId);
        }
    };

    return (
        <div className="mb-1">
            <label htmlFor={name}></label>
            <RichTextEditorComponent
                ref={(scope) => editor = scope}
                id={`ed_${id}`}
                change={(e) => { handleOnChange(e.value); }}
                autoSaveOnIdle={allowEditing}
                insertImageSettings={insertImageSettings}
                toolbarSettings={toolbarSettings}
                quickToolbarSettings={quickToolbarSettings}
                enablePersistence={false}
                saveInterval={3000}
                readonly={!allowEditing}
                height={height}
            >
                <Inject services={[Toolbar, Image, Link, HtmlEditor, Count, QuickToolbar, Table]} />
            </RichTextEditorComponent>
        </div>
    );
}